import React from 'react';
export function TestimonialsSection() {
  return <section className="py-2 bg-white" data-id="element-425">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-426">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-427">
          <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-428">
            Created by a Mom Who Knows Exactly How You Feel
          </h2>
          <div className="flex justify-center mb-6" data-id="element-429">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rCujX65hn9gfodcRqTrBGX/autor.jpg" alt="Dr. Claire Morgan, Pediatric Nutritionist" className="w-48 h-48 rounded-full object-cover border-4 border-blue-100 shadow-md" data-id="element-430" />
          </div>
          <div className="h-1 w-20 bg-yellow-500 mx-auto mb-6" data-id="element-431"></div>
          <p className="text-lg text-gray-700 mb-6" data-id="element-432">
            I've spent 15 years helping families with baby nutrition, but when
            my son Matthew clamped his mouth shut and refused to eat, all my
            expertise meant nothing.
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-433">
            I tried everything. Store-bought purees. Pinterest recipes. Advice
            from every mom group.
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-434">
            <strong data-id="element-435"> Nothing worked. </strong>
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-436">
            At 2 AM one sleepless night, exhausted and defeated, I realized the
            problem:
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-437">
            We don't lack information. We lack structure.
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-438">
            So I created what I desperately needed: a simple system organized by
            my baby's exact developmental stage, not random age ranges.
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-439">
            <strong data-id="element-440">
              The result? Matthew started eating. I stopped crying.
            </strong>
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-441">
            And when I shared this system with my clients, over 10,000 moms
            reported the same transformation.
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-442">
            This isn't theory. It's what saved my sanity and what I now use with
            every family I work with.
          </p>
        </div>
      </div>
    </section>;
}